import { EllipsisVerticalIcon } from "lucide-react";

import { Button } from "@/core/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/core/components/ui/dropdown-menu";
import { cn } from "@/core/utils/func/cn";

export type CardOptionsMenuProps = {
  /** Libellés des entrées du menu (déjà traduits par le consommateur). */
  items?: string[];
  ariaLabel?: string;
  onSelect?: (item: string) => void;
  className?: string;
};

export const CardOptionsMenu = ({
  items = [],
  ariaLabel,
  onSelect,
  className,
}: CardOptionsMenuProps) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={ariaLabel ?? "Menu"}
          className={cn("size-6 rounded-full text-muted-foreground", className)}
        >
          <EllipsisVerticalIcon className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuGroup>
          {items.map((item) => (
            <DropdownMenuItem key={item} onSelect={() => onSelect?.(item)}>
              {item}
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
